// AEHSLoginPage.js
import React, { useState } from 'react';
import HomePage from './HomePage'; // Import the Homepage component
import RegisterAEHS from './RegisterAEHS'; // Import the RegisterAEHS component
import './AEHS.css'; // Main CSS file for overall styling
import AEHSFooter from './AEHSFooter.js';
import { routes } from '../../../helper/routes';
import { history } from '../../../helper/history';
import AEHSLogo from '../../../assets/images/AEHS-Logo.png';


const AEHSLoginPage = () => {
  // State to track the selected tab
  const [selectedTab, setSelectedTab] = useState('home');

  // const [selectedLanguage, setSelectedLanguage] = useState('en');

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const handleRoleSelect = (role) => {
    sessionStorage.setItem("user_role_selection", role)
    history.push(routes.auth_response)
  }

  // const handleLanguageChange = (event) => {
  //   setSelectedLanguage(event.target.value);
  // };

  return (
    <div className="aehs-login-page">
      {/* Navbar with logo, tabs, and login button */}
      <nav className="navbar">
        <div className="navbar-logo">
          <img
            src={AEHSLogo} alt="Logo"
            className="logo"
          />
        </div>
        <div className=" navbar-links">
          {/* Tabs for switching between Home and Promo */}
          <button
            className={`tab-button ${selectedTab === 'home' ? 'active' : ''}`}
            onClick={() => handleTabClick('home')}
          >
            Home
          </button>
          <button
            className={`tab-button ${selectedTab === 'promo' ? 'active' : ''}`}
            onClick={() => handleTabClick('promo')}
          >
            Promo
          </button>
        </div>
        <div className='aehsLoginbtn'>
          <div className="aehsbutton" onClick={() => handleRoleSelect("student")}>Student Login</div>
        </div>
      </nav>

      {/* Render components based on selected tab */}
      <div className="AEHScontent">
        {selectedTab === 'home' ? <HomePage /> : <RegisterAEHS />}
      </div>
      <AEHSFooter />
    </div>
  );
};

export default AEHSLoginPage;
